import axios from '@/plugins/axiosV2'

const http = axios(process.env.VUE_APP_API_VALIJA)

export default {
  obtener_catalogo(codigo) {
    return http.get(`/catalogos/buscar/${codigo}`);
  }
}